import { render, staticRenderFns } from "./cookies-policy.vue?vue&type=template&id=3d2d750e&"
import script from "./cookies-policy.vue?vue&type=script&lang=js&"
export * from "./cookies-policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports